import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export const useHeroAnimation = (ref: React.RefObject<HTMLDivElement | null>) => {
  useGSAP(
    () => {
      gsap.registerPlugin(ScrollTrigger);
      const { current } = ref;
      if (!current) return;
      gsap.set(current, { autoAlpha: 1 });
      const tl = gsap.timeline({
        defaults: {
          ease: 'none',
        },
        scrollTrigger: {
          trigger: current,
          start: 'top top',
          end: 'bottom+=100%',
          scrub: 0.5,
          pin: true,
        },
      });

      tl.timeScale(2)
        .to(current.querySelector('.laptop'), {
          scale: 1,
          duration: 1,
          zIndex: 1,
          ease: 'none',
        })
        .to(current.querySelector('h1'), { alpha: 0, duration: 0.5 }, 0)
        .to(current.querySelector('.icon-logo'), { alpha: 0, duration: 0.5 }, 0)
        .add('mainTitle', '-=0.5')
        .from(current.querySelector('.title'), { y: 50, alpha: 0, duration: 0.5 }, 'mainTitle')
        .from(current.querySelector('.logo'), { y: 50, alpha: 0, duration: 0.3 }, 'mainTitle')
        .from(current.querySelector('.subtitle'), { y: 20, alpha: 0, duration: 0.3 }, 'mainTitle+=0.3')
        .add('icon', '-=0.5')
        .from(current.querySelector('.icon-android'), { y: '-100%', x: '-200%', scale: 0, duration: 0.3 }, 'icon')
        .from(current.querySelector('.icon-bazel'), { y: '100%', x: '-200%', scale: 0, duration: 0.3 }, 'icon')
        .from(current.querySelector('.icon-gbt'), { y: '100%', x: '200%', scale: 0, duration: 0.3 }, 'icon')
        .from(current.querySelector('.icon-sbt'), { y: '-100%', x: '0%', scale: 0, duration: 0.3 }, 'icon')
        .from(current.querySelector('.icon-maven'), { y: '-100%', x: '200%', scale: 0, duration: 0.3 }, 'icon')
        .from(current.querySelector('.main-text .title'), { y: 50, alpha: 0, duration: 0.2 }, '-=0.15')
        .from(current.querySelector('.main-text .subtitle'), { y: 50, alpha: 0, duration: 0.2 }, '-=0.1')
        .from(current.querySelector('.button'), { y: 50, opacity: 0, duration: 0.1 }, '-=0.1');
    },
    { scope: ref },
  );
};
